import React from 'react'
import Scroll from 'react-scroll'
import PerformanceIframeSwitch from '../General/PerformanceIframeSwitch'

let Element = Scroll.Element

const PerformancePage = ({
    showId,
    deeplinkURL, 
    scrollToPosition, 
    cinema
}) => (
    <Element name={scrollToPosition + ' performance-iframe'} className="iframe-container">
        <PerformanceIframeSwitch
            showId={showId}
            deeplinkURL={deeplinkURL}
            scrollToPosition={scrollToPosition}
            cinema={cinema}
        />
    </Element>

)


export default PerformancePage